import { render, staticRenderFns } from "./ShareReward.vue?vue&type=template&id=24cef7f8&scoped=true&"
import script from "./ShareReward.vue?vue&type=script&lang=ts&"
export * from "./ShareReward.vue?vue&type=script&lang=ts&"
import style0 from "./ShareReward.vue?vue&type=style&index=0&id=24cef7f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cef7f8",
  null
  
)

export default component.exports